import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-apibutton',
  templateUrl: './apibutton.component.html',
  styleUrls: ['./apibutton.component.css']
})
export class ApibuttonComponent {
  @Input() text: string = ''
  @Input() progress: boolean = false
  @Input() showSpinner: boolean = true
  @Input() disabled: boolean = false
  // @Output() click: EventEmitter<any> = new EventEmitter();
  constructor() {
    // This is intentional
  }

  get buttonStyle() {
    if (this.disabled)
      return "cursor: default"
    return "cursor: pointer"
  }

}
